if ($('.hoeveel-kan-ik-lenen-wizard-js').length !== 0) {
	$(document).ready(function() {
		
		// Define variables

		var form = $('#hkil-form');
		var formComplete = false;
		
		// Define functions

		//scroll to given selector with an offset of 120 px at the top, on mobile and tablet 20 px
		function goToElementByScroll(selector, extraOffset){
			var definedOffset = 120;
			if(typeof extraOffset == 'undefined'){
				extraOffset = 0;
			}
			if($('html').hasClass('mobile') || $('html').hasClass('tablet')){
				definedOffset = 20;
			}
			definedOffset = definedOffset + extraOffset;
			$('html,body').animate({
				scrollTop: $(selector).offset().top - definedOffset}
			);
		}

		//Calculate bedrag based on all inputs, at the end also set leenbedrag
		function changeBedrag(){
			woning = form.find('select#woning').val();
			leefsituatie = form.find('input[name="leefsituatie"]:checked').data('value');
			kind = form.find('input[name="kinderen"]:checked').data('value');
			woonlasten = Number(form.find("input#brutohypotheeklasten").val());
			nettoInkomen = Number(form.find("input#netto_inkomen").val());
			nettoInkomenPartner = Number(form.find("input#partner_netto_inkomen").val());
			dienstverband = form.find("select#dienstverband").val();
			dienstverbandPartner = form.find("select#partner_dienstverband").val();
			heffingskorting = 124;

			if(leefsituatie == 'Alleenstaand' || dienstverbandPartner == '4')
			{
				nettoInkomenPartner = 0;
			}

			if(dienstverband == '4'){
				nettoInkomen = 0;
			}

			inkomsten = nettoInkomen+nettoInkomenPartner;
			inkomsten_woning = inkomsten;

			if(woning!='2'){
				if(inkomsten > 3446)
				{
					woonlasten = 0.70 * woonlasten;
				}else{
					woonlasten = 0.75 * woonlasten;
				}
			}


			if(leefsituatie == 'Alleenstaand')
			{
				if(kind == 'Ja'){
					norm = 931;
					basishuur = 227;
					maximalisatie = 2877;
					vasteKosten = 1189;
				}else{
					norm = 723;
					basishuur = 227;
					maximalisatie = 3035;
					vasteKosten = 1036;
				}
			}
			else
			{
				if(nettoInkomenPartner == 0)
				{
					nettoInkomen = (nettoInkomen + heffingskorting);
					inkomsten = (inkomsten + heffingskorting);
				}

				if(kind == 'Ja'){
					norm = 1273;
					basishuur = 227;
					maximalisatie = 2877;
					vasteKosten = 1479.55;
				}else{
					norm = 1172;
					basishuur = 227;
					maximalisatie = 3035;
					vasteKosten = 1417.40;
				}
			}

			levensonderhoud = (0.15 * ((nettoInkomen + nettoInkomenPartner) - basishuur - norm)) + norm;

			if(inkomsten > maximalisatie)
			{
				levensonderhoud = vasteKosten;
			}

			termijnbedrag = inkomsten - woonlasten - levensonderhoud;

			leencapaciteit =  Math.ceil(termijnbedrag * 50);

			if(leencapaciteit < 0)
				leencapaciteit = 0;
			else
				leencapaciteit = leencapaciteit;

			if(leencapaciteit == 0)
			{
				leenbedrag = "€ 0,-";
				leenbedragRaw = leencapaciteit.toFixed(0);
			}
			else
			{
				var leenbedrag = $().number_format(leencapaciteit.toFixed(0), numberFormatEuroOptions);
				leenbedrag = "€ " + leenbedrag + ",-";
				leenbedragRaw = leencapaciteit.toFixed(0);
			}

			setMaxLeenbedrag(leenbedrag);
		}

		// Set the labels and texts of leenbedrag to given amount
		function setMaxLeenbedrag(leenbedrag){
			$(".max-leenbedrag").find('span.total').text(leenbedrag);
			$(".max-leenbedrag-overzicht").find('span.total').text(leenbedrag);
		}

		// Change the sidebar info to match the given input's value
		function changeInfoText(element){
			var inputName = element.attr('name');
			var targetElem = $('.hkil-overzicht b[data-connected-field="'+inputName+'"]');
			var value = '';

			if(element.prop('type') == 'radio'){
				value = $('input[type="radio"][name='+ inputName +']:checked').data('value');
			}else if(element.find('option').length > 0){
				value = element.find('option[value="'+element.val()+'"]').data('value');
			}else{
				value = element.val();
			}

			targetElem.html(value);
		}

		function validateCurrentStep(input){
			var isValid = true;
			input.closest('.hkil-stap').find('input').each(function(){
				var inputName = $(this).attr('name');
				var closestRow = $(this).closest('.row');

				if(($(this).attr('type') == 'radio' && $('input[type="radio"][name='+ inputName +']:checked').length == 0)){
					closestRow.addClass('error');
					isValid = false;

				}else if($(this).val() === '' && $(this).is(':visible')){
					$(this).addClass('error');
					isValid = false;

				}else if($(this).hasClass('error')){
					$(this).removeClass('error');

				}else if(closestRow.hasClass('error')){
					closestRow.removeClass('error');
				}
			});
			return isValid;
		}

		function enableNextStep(inputElement){
			var currentStep = inputElement.closest('.hkil-stap');
			var nextStep = currentStep.next('.hkil-stap');
			nextStep.removeClass('inactive');
			currentStep.find('.button').removeAttr('disabled');
		}

		function switchActiveButton(selectedButton){
			selectedButton.closest('.button-group').find('.active').removeClass('active');
			selectedButton.find('.button').addClass('active');
		}

		// set partner info visible based on given input
		function switchVisiblePartnerInfo(inputElement){
			if(inputElement.data('value') == 'Samenwonend'){
				$('.partner-info input, .partner-info select').each(function(){
					$(this).prop('disabled', false);
				});
				$('.partner-info').show();
				//Hide partner income row if dienstverband is geen
				if(form.find('select[name="partner_dienstverband"]').val() == '4'){
					form.find('input[name="partner_netto_inkomen"]').closest('.row').hide();
				}
			}else{
				$('.partner-info').hide();
				$('.partner-info input, .partner-info select').each(function(){
					$(this).prop('disabled', true);
				});
			}
		}

		function enableAllButtons(){
			$('#hkil-form .button:disabled').each(function(){
				$(this).prop('disabled',false);
			});
		}

		
		function finalizeForm(nextButton){
			changeBedrag();

			nextButton.closest('.hkil-stap').next('.max-leenbedrag').removeClass('inactive');
			goToElementByScroll(nextButton.closest('.hkil-stap').next('.max-leenbedrag'));

			enableAllButtons();

			formComplete = true;
		}

		function switchIncomeFieldVisible(inputElement){
			var inputName = inputElement.attr('name');
			var connectedOverzichtField = $('.hkil-overzicht b[data-connected-field="'+inputName+'"]');
			if(inputElement.val() == '4'){
				inputElement.closest('.row').next('.row').hide();
				connectedOverzichtField.closest('p').next('p').hide();
			}else{
				inputElement.closest('.row').next('.row').show();
				connectedOverzichtField.closest('p').next('p').show();
			}
		}

		function checkCurrentStep(inputElement){
			var currentStep = inputElement.closest('.hkil-stap');
			var isValid = true;
			currentStep.find('input').each(function(){
				var inputName = $(this).attr('name');
				var closestRow = $(this).closest('.row');

				if(($(this).attr('type') == 'radio' && $('input[type="radio"][name='+ inputName +']:checked').length == 0)){
					isValid = false;

				}else if($(this).val() === '' && $(this).is(':visible')){
					isValid = false;
				}
			});
			return isValid;
		}

		function switchInfoForHomeSituation(inputElement){
			var woonsituatie = inputElement.val();
			var currentStep = inputElement.closest('.hkil-stap');
			var nextStep = currentStep.next('.hkil-stap');
			

			if(woonsituatie == '6'){
				$('.home-type-warning').show();
				goToElementByScroll('.home-type-warning', 200);
				$('.hide-on-thuiswonend').hide();
				nextStep.addClass('inactive');
			}else{
				$('.home-type-warning').hide();
				$('.hide-on-thuiswonend').show();
				if($('#brutohypotheeklasten').val() != ''){
					nextStep.removeClass('inactive');
				}
			}
		}

		// Begin triggers

		if(form.length > 0){

			form.find('input[name="leefsituatie"]').on('change', function(){
				var leefsituatieInput = $(this);
				switchVisiblePartnerInfo(leefsituatieInput);
			});

			form.find('select[name="woning"]').on('change', function(){
				var woonsituatieInput = $(this);
				switchInfoForHomeSituation(woonsituatieInput);
			});

			$('.hkil-stap input , .hkil-stap select').on('change',function(){
				var inputElement = $(this);
				if(inputElement.attr('name') == 'dienstverband' || inputElement.attr('name') == 'partner_dienstverband'){
					switchIncomeFieldVisible(inputElement);
				}
				changeInfoText(inputElement);
				if(inputElement.attr('name') != 'woning' && checkCurrentStep(inputElement)){
					enableNextStep(inputElement);
				}
				if(formComplete){
					changeBedrag();
				}
			});

			$('.button-group label').on('click',function(){
				var button = $(this);
				switchActiveButton(button);
			});

			$('.hkil-stap .next-stap').on('click',function(e){
				var nextButton = $(this);
				if(nextButton.attr('disabled') == 'disabled'){
					e.preventDefault();
					return false;
				}
				if(validateCurrentStep(nextButton)){

					if(nextButton.hasClass('get-result')){
			 			$('.hkil-stap').each(function(){
							var currentStep = nextButton.closest('.hkil-stap');
							currentStep.find('input:visible, select:visible').each(function(){
								changeInfoText($(this));
							});
						});
			 			finalizeForm(nextButton);

					}else{
						var currentStep = nextButton.closest('.hkil-stap');
							currentStep.find('input:visible, select:visible').each(function(){
								changeInfoText($(this));
							});

						goToElementByScroll(nextButton.closest('.hkil-stap').next('.hkil-stap'));

					}
				}

			});
			//trigger samenwonend en kinderen nee, to show active states of the form button
			$('label[for="lsamen"], label[for="knee"]').trigger('click');
		}
	});
}